import React from "react";

import {
  Class,
  JSTypeOperator,
  ObjectTypes,
} from "../../../../GenericCoreGraph/ClassFramework/Class";
import SellerAvailabilityCalendarModalStyles from "../../../../../ScriptStyles/SellerAvailabilityCalendarModalStyles";
import TObject from "../../../../TagComponents/TObject";
import GenericWebGraph from "../../../../GenericWebController/GenericWebGraph"

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CreateIcon from "@material-ui/icons/Create";
import GridItem from "../../../../../components/Grid/GridItem";
import TBigCalender from "../../../Components/BigCalender/TBigCalender";
import GridContainer from "../../../../../components/Grid/GridContainer";
import DialogActions from '@material-ui/core/DialogActions';
import DefaultTheme from "../../../../../Themes/DefaultTheme";

import TBaseDialogModal from '../../../Utilities/TBaseDialogModal';
import { CircularProgress } from "@material-ui/core";


var TSellerAvailabilityCalendarModal = Class(
  TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TSellerAvailabilityCalendarModal"),
    constructor: function (_Props) {
      TSellerAvailabilityCalendarModal.BaseObject.constructor.call(
        this,
        _Props
      );
      this.state = {
        ...this.state,
        sellerDetailId: null,
        sellerLessonID: null,
        isGroupLesson: false,
        preview: true,
        open: false,
        sellerLessons: null,
        rates: [],
        currencies: [],
        selectedLessonKey: null,
        selectedLesson: null,
        isSellerOrAdmin: false,
        loadingActivate: false,
      };
      window.App.SellerAvailabilityCalendarModal = this;
      this.BigCalender_AvailableTimeRef = React.createRef();
    }
    ,
    Destroy: function () {
      TSellerAvailabilityCalendarModal.BaseObject.Destroy.call(this);
    }
    ,
    /* Params: _SellerDetailId, _SellerLessonID, _IsGroupLesson, _Preview */
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TSellerAvailabilityCalendarModal.BaseObject.HandleClickOpen.call(this, _ParamObject, _CallbackOnClose);
      this.CallbackOnClose = _CallbackOnClose;
      this.setState({
        open: true,
        sellerDetailId: _ParamObject.SellerDetailId,
        sellerLessonID: _ParamObject.SellerLessonID,
        isGroupLesson: _ParamObject.IsGroupLesson,
        sellerLessons: _ParamObject.sellerLessons,
        sellerDetail: _ParamObject.sellerDetail,
        preview: _ParamObject.Preview
      });
    }
    ,
    HandleClose: function () {
      this.setState({
        open: false,
        sellerDetailId: null,
        sellerLessonID: null,
        isGroupLesson: false,
        preview: true
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    }
    ,
    HandleGetBookingButtonContent: function () {
      const { classes } = this.props;
      var __This = this;
      if (__This.state.loadingActivate) {
        return (
          <CircularProgress
            style={{
              width: "24.5px",
              height: "24.5px",
              color: DefaultTheme.palette.default.main,
            }}
          />
        );
      } else {
        return __This.state.Language.LessonBookNow;
      }
    },
    HandleOpenSelectAndBuyLessonModal: function () {
      var __This = this;
      __This.setState({ loadingActivate: true }, () => {
        window.App.LoginPageModal.HandleClickOpen(null, function (_isLogined) {
          if (_isLogined) {
            if (
              !window.App.User.FreeLessonUse ||
              __This.state.selectedLesson.Credit > 0
            ) {
              __This.setState({ loadingActivate: false }, () => {
                window.App.SelectAndBuyLessonModal.HandleClickOpen({
                  SellerLessons: __This.state.sellerLessons,
                  SellerDetailId: __This.props.sellerDetailId,
                  UserSellerDetail: __This.state.sellerDetail,
                  SelectedLesson: __This.props.lessonId,
                  OpenType: 1,
                });
              });
            } else {
              window.App.MessageBox.ShowMessage(
                __This.state.Language.Warning,
                __This.state.Language.FreeLessonUse,
                "danger",
                true
              );
            }
          } else {
            __This.setState({ loadingActivate: false });
          }
        });
      });
    },
    render: function () {
      var __This = this;
      const { classes } = this.props;
      var __Params = TSellerAvailabilityCalendarModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return null;
      }
      return (this.HandleWrapModal(
        <div>
          <DialogContent>
            <TBigCalender
              owner={this}
              scrolltofirst={true}
              //asyncload={this.HandleBigCalenderAsycLoad}
              sellerDetailId={__This.state.sellerDetailId}
              lessonId={__This.state.sellerLessonID}
              ref={this.BigCalender_AvailableTimeRef}
              starthour={0}
              startminute={0}
              endhour={24}
              endminute={0}
              stepminute={30}
              type={__This.state.isGroupLesson ? window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class : window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Individual}
              wrapmodal={false}
              heighcalibrator={this.state.IsFullScreen ? 280 : 420}
              locked={this.state.preview}
              availability={false}
              dialogActions={<DialogActions>
                {this.state.preview && (
                  <>
                    <Button onClick={this.HandleClose} color="primary">
                      {this.state.Language.Close}
                    </Button>
                  </>
                )
                }
              </DialogActions>}
            />
          </DialogContent>
        </div>)
      );
    },
  },
  {}
);

export default withStyles(SellerAvailabilityCalendarModalStyles)(
  TSellerAvailabilityCalendarModal
);
